import { CLEARFORMFIELDS, SETFORMFIELDS } from "../actions/templateActions";

const initialState = {
    templateLabels: '',
    templateValues: ''
}

export const templateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SETFORMFIELDS:
            return { ...state, templateLabels: action.payload.labels, templateValues: action.payload.values };
        case CLEARFORMFIELDS:
            return { ...state, templateLabels: action.payload.labels, templateValues: action.payload.values };
        default:
            return state;

    }
}